import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LoginForm, TwoFactorAuthValidationForm } from './components';
import './Login.css';
import { AuthShell } from '../../components/AuthShell';
import { useUser } from '../../contexts/UserContext';
import { setUserId } from '../../utils/googleAnalytics';

export const Login = () => {
  const { isLoggedIn, redirectUrl } = useAuth();
  const { user } = useUser();

  const navigate = useNavigate();
  const [rememberUser, setRememberUser] = useState<boolean>(false);

  const [preAccessToken, setPreAccessToken] = useState<any>();

  useEffect(() => {
    if (isLoggedIn && user?.id) {
      setUserId(user.id);
    }
  }, [isLoggedIn, user?.id]);

  useEffect(() => {
    if (isLoggedIn) {
      navigate(redirectUrl ?? '/member-portal');
    }
  }, [isLoggedIn, navigate, redirectUrl]);

  return (
    <AuthShell>
      {preAccessToken ? (
        <TwoFactorAuthValidationForm
          rememberUser={rememberUser}
          preAccessToken={preAccessToken}
        />
      ) : (
        <LoginForm
          setRememberUser={setRememberUser}
          setPreAccessToken={setPreAccessToken}
        />
      )}
    </AuthShell>
  );
};
